// please use this pattern for all mixpanel events:
// "FEATURE__DETAILS_ABOUT_THE_EVENT" notice the double underscore after the feature name

// event names (the string value) should be easy to understand and describe why they matter in the users flow regarding the feature they are using
// try to describe what is happening in a human readable way
// use words like "navigated", "contacted", "sent", "closed" etc instead of just "clicked"

// event constant names do not need to be as descriptive, they are only dev facing

const AUTH__SUNRUN_LOGIN_INITIATED = "Auth - Sunrun Login Initiated";
const AUTH__PARTNER_LOGIN_INITIATED = "Auth - Partner Login Initiated";
const AUTH__VALIDATED_PROFILE = "Auth - Validated Profile";
const AUTH__TOKEN_REFRESHED = "Auth - Token Refreshed";
const AUTH__CODE_EXCHANGE_INITIATED = "Auth - Code Exchange Initiated";
const AUTH__TOKEN_TRANSFER_INITIATED = "Auth - Token Transfer Initiated";

export {
  AUTH__SUNRUN_LOGIN_INITIATED,
  AUTH__PARTNER_LOGIN_INITIATED,
  AUTH__VALIDATED_PROFILE,
  AUTH__TOKEN_REFRESHED,
  AUTH__CODE_EXCHANGE_INITIATED,
  AUTH__TOKEN_TRANSFER_INITIATED,
};
